<template>
  <div v-if="ready" class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="login">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>

                  <b-input-group class="mb-3">
                    <template #prepend>
                      <b-input-group-text>
                        <font-awesome-icon :icon="['fal', 'user']" />
                      </b-input-group-text>
                    </template>

                    <b-form-input
                      v-model="form.email"
                      type="email"
                      placeholder="Email"
                    ></b-form-input>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <template #prepend>
                      <b-input-group-text>
                        <font-awesome-icon :icon="['fal', 'lock']" />
                      </b-input-group-text>
                    </template>

                    <b-form-input
                      v-model="form.password"
                      type="password"
                      placeholder="Password"
                    ></b-form-input>
                  </b-input-group>

                  <b-button type="submit" variant="primary" class="px-4">
                    Login
                    <font-awesome-icon :icon="['fal', 'sign-in']" />
                  </b-button>
                  <b-btn v-b-modal.password-reset variant="secondary" class="float-right">
                    Forgot your password?
                  </b-btn>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none">
              <b-card-body class="text-center">
                <div>
                  <img
                    src="data:image/png;base64,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"
                    alt="BOLT"
                    class="logo"
                  />

                  <p>
                    Welcome to BOLT Administration User Interface. You need to have a valid
                    administrator credential to proceed.
                  </p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>

    <b-modal id="password-reset" ref="passwordResetRef" :hide-footer="true" title="Reset Password">
      <b-form @submit.prevent="resetPasswordEmail">
        <p class="text-muted">
          Lost your password? Please enter your username or email address. You will receive a link
          to create a new password via email.
        </p>

        <form-email
          v-model="resetForm.email"
          name="email"
          :actual-form="resetForm"
          placeholder="Your email here"
          :labelless="true"
          required
        />

        <b-button type="submit" variant="warning" class="px-4 float-right"> Reset </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import externals from "@/constants/externals";
import defineRulesFor from "@/imports/ability";
import JwtManager from "@/imports/jwt-manager.js";
import resolveSafeRedirect from "@/imports/safe-redirect";

export default {
  name: "Login",

  data() {
    return {
      form: {
        email: "",
        password: "",
        source: "webui",
      },

      resetForm: new window.AppForm({
        email: "",
      }),

      redirect: null,
      ready: false,
    };
  },

  computed: {
    isLocal() {
      return window.location.hostname === "localhost" || window.location.hostname.endsWith(".test");
    },
  },

  mounted() {
    if (this.isLocal) {
      this.form.email = this.$lodash.get(process.env, "VUE_APP_LOCAL_USERNAME");
      this.form.password = this.$lodash.get(process.env, "VUE_APP_LOCAL_PASSWORD");
    }

    const redirect = resolveSafeRedirect(this.$route.query.redirect);
    if (redirect && redirect.href !== `${window.location.origin}/`) {
      this.redirect = redirect;
    }

    if (this.$route.query.enforce_token) {
      this.$auth.token("auth_token_default", this.$route.query.enforce_token, false);
    }

    // Check if is already logged in
    if (this.$auth.check() || this.$route.query.enforce_token) {
      const existingToken = JwtManager.getToken();
      const currentToken = this.$auth.token();
      if (currentToken && (!existingToken || existingToken.length === 0)) {
        // Somehow has a valid token, but not stored in cookie
        // Set it in cookie
        JwtManager.setCookie(currentToken);
      }

      if (this.redirect) {
        this.followRedirect();
        return;
      }

      this.$router.push({
        name: "jobs.dispatch",
      });

      if (this.$route.query.enforce_token) {
        this.$nextTick(() => {
          return window.location.reload();
        });
      }

      return;
    }

    // Not logged in, let's clear SSO cookie
    JwtManager.clearCookie();

    this.ready = true;

    this.$nextTick(() => {
      if (this.$route.hash === "#forgot-password") {
        this.$bvModal.show("password-reset");
      }
    });
  },

  methods: {
    login() {
      const external = this.isExternalRedirect();
      const defaultRedirect = external ? null : { name: "jobs.dispatch" };

      this.$auth
        .login({
          body: this.form,
          staySignedIn: true,
          redirect: this.redirect && !external ? this.inAppRedirectPath() : defaultRedirect,
        })
        .then(
          () => {
            const user = this.$auth.user() || {};

            this.$ability.update(defineRulesFor(user));
            window.toastr.success("Logged in successfully!", "Success");

            JwtManager.setCookie(this.$auth.token());

            if (external) {
              this.followRedirect();
            }

            if (!user || !user.has_webui_access) {
              if (externals && externals.dash && externals.dash.domain) {
                window.location = externals.dash.domain;
              }
            }
          },
          () => {
            window.toastr.error("Login failed!");
          }
        );
    },

    resetPasswordEmail() {
      this.resetForm
        .post("/password/email")
        .then(() => {
          this.$refs.passwordResetRef.hide();
          window.toastr.success(
            "Password reset initiated; check the email to complete password reset",
            "Success"
          );
        })
        .catch(() => {
          window.toastr.warning(
            "An error occurred when trying to initiate password reset!",
            "Warning"
          );
        });
    },

    isExternalRedirect() {
      return Boolean(this.redirect) && this.redirect.origin !== window.location.origin;
    },

    inAppRedirectPath() {
      return `${this.redirect.pathname}${this.redirect.search}${this.redirect.hash}`;
    },

    followRedirect() {
      if (this.isExternalRedirect()) {
        window.location = this.redirect.href;
        return;
      }

      this.$router.push(this.inAppRedirectPath());
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.logo {
  width: 90px;
  padding: 20px 0;
}
</style>
